/**
 * assets/op-urgency-bar.js
 *
 * Initializes .op-urgency-bar countdowns wherever they appear in the DOM —
 * server-rendered on page load (PDP) AND injected later via innerHTML
 * (quick add modal, cart drawer, section rendering, etc).
 *
 * Browsers do not execute <script> tags that arrive via innerHTML, so this
 * file must be loaded once, site-wide, as a normal asset (not inlined in
 * the snippet that gets AJAX-fetched). A MutationObserver watches for new
 * .op-urgency-bar elements and starts/stops their timers as they're
 * added to or removed from the DOM (e.g. quick add opening/closing).
 */
(function () {
  var intervals = new WeakMap();

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function secondsUntilMidnight() {
    var now = new Date();
    var midnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1,
      0, 0, 0, 0
    );
    return Math.floor((midnight - now) / 1000);
  }

  function tick(bar) {
    var elH = bar.querySelector('.op-urg-h');
    var elM = bar.querySelector('.op-urg-m');
    var elS = bar.querySelector('.op-urg-s');
    if (!elH || !elM || !elS) return;

    var total = secondsUntilMidnight();
    if (total <= 0) total = 86400;

    elH.textContent = pad(Math.floor(total / 3600));
    elM.textContent = pad(Math.floor((total % 3600) / 60));
    elS.textContent = pad(total % 60);
  }

  function initBar(bar) {
    if (bar.dataset.opUrgInit === 'true') return;
    bar.dataset.opUrgInit = 'true';

    tick(bar);
    var id = window.setInterval(function () {
      tick(bar);
    }, 1000);
    intervals.set(bar, id);
  }

  function teardownBar(bar) {
    var id = intervals.get(bar);
    if (id) {
      window.clearInterval(id);
      intervals.delete(bar);
    }
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;

    if (root.classList && root.classList.contains('op-urgency-bar')) {
      initBar(root);
    }
    root.querySelectorAll('.op-urgency-bar').forEach(initBar);
  }

  // Initialize any bars already in the DOM (e.g. server-rendered on PDP).
  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
  });
  // In case this script loads after DOMContentLoaded already fired.
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    scan(document);
  }

  // Catch bars injected later — quick add modal, cart drawer, etc.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
      mutation.removedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('op-urgency-bar')) {
          teardownBar(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.op-urgency-bar').forEach(teardownBar);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();